import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { themeSSRManager } from '@confluence/ssr-utilities/entry-points/ThemeSSRManager';
import { getEffectiveThemeState } from '@confluence/theming-utils/entry-points/getEffectiveTheme';
import { expValEquals } from '@confluence/feature-experiments';

import type {
	UserSettingsQuery as UserSettingsQueryType,
	UserSettingsQueryVariables as UserSettingsQueryVariablesType,
} from './__types__/UserSettingsQuery';
import { UserSettingsQuery } from './UserSettingsQuery.graphql';

export const API_DEFAULT_THEME_STATE = 'default';

export const preloadUserSettingsForSSR = async ({ themeState }: { themeState?: string }) => {
	const { isLicensed, isLoggedIn } = getPreloaderFnContext();

	if (!isLoggedIn) {
		return;
	}

	// Apply themeState immediately if provided via query param (always defined for embedded pages)
	if (themeState) {
		themeSSRManager.setThemeStateBasedOnSavedThemeState(
			getEffectiveThemeState(decodeURIComponent(themeState)),
		);
	}

	const response = await query<UserSettingsQueryType, UserSettingsQueryVariablesType>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: UserSettingsQuery,
		variables: {
			isNotLicensed: !isLicensed,
		},
	});

	const theme = response?.data?.userPreferences?.theme;

	// Apply user preference theme only when no themeState is provided (prevents flicker from mismatch)
	if (expValEquals('confluence_preview_panels_exp', 'isEnabled', true)) {
		if (!themeState && theme) {
			themeSSRManager.setThemeStateBasedOnSavedThemeState(getEffectiveThemeState(theme));
		}
	} else {
		if (theme) {
			themeSSRManager.setThemeStateBasedOnSavedThemeState(getEffectiveThemeState(theme));
		}
	}

	return response;
};
